import "nav.js";
import "navigation.js";

import "scss/main.scss";

//Blocks and components with JS
import "blocks/anchor-block/public/anchor-block.js";


var skipLink = document.querySelector('.skip-link');
skipLink.addEventListener('click', function(e) {
  document.querySelector(skipLink.getAttribute('href')).focus();
});

